<script lang="ts">
    import { MUNIO } from "$lib/munio";
    import { page } from "$app/stores";
    import showToast from "$lib/components/toasts/toaster";

    export let primaryColor: string;

    let viewCategory = false;
    let loadingSubscribe = false;
    let loading_login = false;
    let validateEmail = false;

    let name = "";
    let email = "";
    let message = "";

    const handleChangeEmail = (event: any) => {
        const valueEmail = event.target.value;
        const resultValidate = !!valueEmail.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        if (resultValidate) {
            email = valueEmail;
            validateEmail = true;
        } else {
            validateEmail = false;
        }
    };

    const handleChangeName = (event: any) => {
        const valueName = event.target.value;
        name = valueName;
    };

    const handleSubmitSubscribe = async () => {
        // event.preventDefault();
        loadingSubscribe = true;
        MUNIO.initMunio(await MUNIO.getClientKey($page.url.origin));
        const response = await MUNIO.subscribeMember({
            name,
            email,
        });

        if (response?.data?.message === "Registration success.") {
            loadingSubscribe = false;
            // Jika sukses, tambahkan pesan respon dan ubah latar belakang
            message = "Subscribe successfully!";
            if (message) {
                name = "";
                email = "";
                showToast(message, "success");
                // setTimeout(() => {
                // goto('/')
                // }, 1000);
            }
        } else {
            loadingSubscribe = false;
            // Jika gagal, tambahkan pesan respon dan ubah latar belakang
            name = name;
            email = email;
            message = response?.error?.message;
            if (message) {
                showToast(message, "error");
            }
        }
    };
</script>

<h3 class="text-base mb-2">NEWSLETTER</h3>
<p>
    Dapatkan berita Catch Me Up! langsung di inbox-mu setiap hari Senin-Jumat
    pukul 06.00 WIB
</p>

<form id="registerForm" on:submit={handleSubmitSubscribe}>
    <div class="mb-3">
        <label for="fullName" class="font-medium text-base text-slate-600"
            >Nama Lengkap</label
        >
        <input
            required
            type="text"
            bind:value={name}
            class="form-control min-w-full !placeholder-slate-400 !py-3 mt-1"
            placeholder="Nama Lengkap"
            on:input={handleChangeName}
        />
    </div>
    <div class="mb-3">
        <label for="emailAddress" class="font-medium text-base text-slate-600"
            >Email</label
        >
        <input
            required
            type="email"
            bind:value={email}
            class="form-control min-w-full !placeholder-slate-400 !py-3 mt-1"
            placeholder="Alamat Email"
            on:input={handleChangeEmail}
        />
    </div>

    <div class="d-grid mt-4">
        <!-- style="background-color: {primaryColor}; opacity: {( loading || !validateEmail || name === '' || email === '' ) ? 0.5 : 1}; pointer-events: {( loading || name === '' || email === '') ? 'none' : 'auto'}" -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button
            type="submit"
            style="background-color: {primaryColor}"
            class={`register-button w-full py-[1rem] cursor-pointer rounded-lg justify-center items-center gap-1 inline-flex text-neutral-50 text-sm font-semibold lg:text-md`}
        >
            {loadingSubscribe ? "On progress subscribe..." : "Berlangganan"}
        </button>
    </div>
</form>
